import ButtonLink from 'components/display/ButtonLink'
import SimpleAnchor from 'components/display/SimpleAnchor'
import { SectionTitle, SectionSubtitle } from 'pages/static/section'
import HowItWorksSteps from '../../onboarding/HowItWorksSteps'
import { HeaderCentered, ButtonWrapper, SupportTextWrapper } from '../styles'

const HowItWorks = () => {
  return (
    <>
      <HeaderCentered>
        <SectionTitle>How It Works</SectionTitle>
        <SectionSubtitle>Joining our Host community</SectionSubtitle>
      </HeaderCentered>

      <HowItWorksSteps isInvited={false} />

      <ButtonWrapper style={{ marginTop: '32px' }}>
        <ButtonLink href="/my/listings/new" inline>
          Get started
        </ButtonLink>

        <SupportTextWrapper>
          Need help signing up as a Host?{' '}
          <SimpleAnchor href="mailto:support@riparide.com">
            Contact our Support Team
          </SimpleAnchor>
        </SupportTextWrapper>
      </ButtonWrapper>
    </>
  )
}

export default HowItWorks
